export default __webpack_public_path__ + "static/media/check-circle-filled.23b1f0ed.svg";